export enum CartType {
  normal = 'normal',
  bundle = 'bundle',
  hotdish = 'hotdish',
  pantry = 'pantry',
  groupbuy = 'groupbuy_hotdish',
  alcohol = 'alcohol',
  seller = 'seller',
  presale_normal = 'presale_normal',
  presale_pantry = 'presale_pantry',
  presale_seller = 'presale_seller'
}

export enum SimpleCartStatus {
  actived = 'A',
  canceled = 'C'
}
/**
 * 提示信息类型
 */
export enum TagInfoType {
  /**满邮 */
  Grocery = 'Grocery',
  /**换购 */
  Deal = 'Deal',
  pantry = 'pantry',
  seller = 'Seller',
  /** 68换购 */
  trade_in_upsell = 'trade_in_upsell'
}

export enum CartSectionType {
  Global = 'Global+',
  Grocery = 'Grocery',
  Restaurant = 'Restaurant'
}
